import React from 'react';
import { useLocation, Route, Routes, Navigate } from 'react-router-dom';
// reactstrap components
import { Container } from 'reactstrap';
// core components
import AdminNavbar from 'components/Navbars/AdminNavbar.js';
import Sidebar from 'components/Sidebar/Sidebar.js';

import routes from 'routes.js';

const Student = (props) => {
  const mainContent = React.useRef(null);
  const location = useLocation();

  React.useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
    mainContent.current.scrollTop = 0;
  }, [location]);

  const getRoutes = (routes) => {
    return routes.map((prop, key) => {
      if (prop.layout === '/student') {
        return (
          <Route path={prop.path} element={prop.component} key={key} exact />
        );
      } else {
        return null;
      }
    });
  };

  const getBrandText = (path) => {
    for (let i = 0; i < routes.length; i++) {
      if (
        props?.location?.pathname.indexOf(routes[i].layout + routes[i].path) !==
        -1
      ) {
        return routes[i]?.name;
      }
    }
    return 'Brand';
  };

  return (
    <>
      <Sidebar
        {...props}
        routes={routes.filter((route) => route.layout === '/student')}
        logo={{
          innerLink: '/student/index',
          imgSrc: "https://res.cloudinary.com/djg7v9dna/image/upload/v1739198257/Logo/kgamz0yjfr9uy8dsbnur.webp",
          imgAlt: '...',
        }}
      />
      <div className='main-content app-compact-ui' ref={mainContent}>
        <AdminNavbar
          {...props}
          brandText={getBrandText(props?.location?.pathname)}
        />
        <Routes>
          {getRoutes(routes)}
          <Route path='*' element={<Navigate to='/student/index' replace />} />
        </Routes>
        <Container fluid>
          {/* <AdminFooter /> */}
          <div className='p-3' />
        </Container>
      </div>
    </>
  );
};

export default Student;
